import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsEquipmentInstance, PmsEquipmentInstance } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsEquipmentInstance>
    useData={usePmsEquipmentInstance}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
